<tran-ui-content-section backgroundColor="deep-blue-850">
    <div class="flex flex-col lg:flex-row gap-20 w-full pt-[64px] pb-[80px]">
        <div class="full-w lg:w-[53.125%] flex flex-col !gap-6">
            <h2 class="text-hero-xs-1">
                <span class="font-bold">{{ 'home.transformation-funds.bold-heading' | translate }}</span>
            </h2>
            <p class="text-copy-l">{{ 'home.transformation-funds.description' | translate }}</p>
            <tran-checklist [items]="HOME_CHECKLIST" />
            <tran-primary-button
                [label]="'home.transformation-funds.cta-label' | translate"
                [href]="'home.transformation-funds.cta-link' | translate"
                [ariaLabel]="'home.transformation-funds.cta-aria-label' | translate"
            />
        </div>
        <div class="flex flex-col gap-2 justify-center full-w lg:w-[40.625%]">
            <div class="bg-deep-blue-800 rounded-lg min-h-[290px] flex flex-col items-start justify-center !px-10">
                <div class="flex flex-row gap-1 align-items-center">
                    <div class="text-[56px] text-bold-green element-saving"></div>
                    <div class="font-bold text-hero-xs-4">
                        {{ 'home.transformation-funds.tiles.main-tile.icon-heading' | translate }}
                    </div>
                </div>
                <div class="font-bold text-hero-l2">
                    {{ 'home.transformation-funds.tiles.main-tile.heading' | translate }}
                </div>
            </div>
            <div class="flex flex-row gap-2 w-full min-h-[224px]">
                <div class="flex flex-col bg-deep-blue-800 rounded-lg w-[50%] !p-10 gap-4">
                    <div class="text-[56px] text-bold-green element-send"></div>
                    <div>
                        <p class="text-copy-xs">
                            {{ 'home.transformation-funds.tiles.sub-tile-1.description' | translate }}
                        </p>
                        <p class="font-bold text-copy-xs">
                            {{ 'home.transformation-funds.tiles.sub-tile-1.bold-description' | translate }}
                        </p>
                    </div>
                </div>
                <div class="flex flex-col bg-deep-blue-800 rounded-lg w-[50%] !p-10 gap-4">
                    <div class="text-[56px] text-bold-green element-rocket"></div>
                    <div>
                        <p class="text-copy-xs">
                            {{ 'home.transformation-funds.tiles.sub-tile-2.description' | translate }}
                        </p>
                        <p class="font-bold text-copy-xs">
                            {{ 'home.transformation-funds.tiles.sub-tile-2.bold-description' | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</tran-ui-content-section>
